<form #folderForm="ngForm" (ngSubmit)="save()" name="folderForm">
  <h2 mat-dialog-title>Create new folder</h2>
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>Folders name</mat-label>
      <input [(ngModel)]="newDirectory.Name" matInput minlength="3" name="Name" pattern="[a-zA-Z0-9\s]+" required type="text">
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close mat-raised-button type="button">Close</button>
    <div class="fill-remaining-space"></div>
    <app-button [disabled]="!folderForm.form.valid"></app-button>
  </mat-dialog-actions>
</form>
